import { InputThemes } from "../../_models/formsThemes.interface";

export const InputsThemes: InputThemes = {
  'input-white-theme': {
    standar: 'input-white-theme',
    focus: 'is-input-white-theme-focus'
  },
  'input-red-theme': {
    standar: 'input-red-theme',
    focus: 'is-input-red-theme-focus'
  }
};
